import React from "react";
import "./About.css";
const About = () => {
  return (
    <section id="about" className="container section">
      <div className="row">
        <div
          className="col-md-10"
          data-aos="fade-up"
          data-aos-easing="linear"
          data-aos-duration="500"
        >
          <h2 id="hello_header" className="section__title">
            Hello_
          </h2>
          <p className="section__description pe-lg-5">
            Kewal, here. I live with my family in Berhampur, Odisha. I have
            graduated from Berhampur University with a Masters' degree in
            Computer Applications in the year 2020. Have then moved to Hyderabad
            and got an opportunity to work in an IT firm as an intern in the
            role of 'Back-end Developer' for 6 months. Further, I realized my
            inclination for learning more about full Stack development with
            JavaScript. So I started knowing more about the technologies and
            simultaneously evaluated my understanding with assignments and
            projects. Now I am actively looking forward to work with passionate
            minds and learn along side while I give my best to an organization.
            During my leisure, I love to play games on my system or console, try
            out new recipes and watch Anime. Let's connect!
          </p>
          <a
            href="https://drive.google.com/file/d/1Dr6QORlZNO8P1dyqldyhjDBnJzYBThfG/view?usp=sharing"
            target="_blank"
            className="section_btn site-btn"
            data-aos="zoom-in"
            data-aos-easing="linear"
            data-aos-duration="500"
          >
            <img alt="" />
            Download Resume
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
